/** @format */

import Axios from 'axios';
// import get from "lodash/get";

export class Api {
  _axios;
  constructor() {
    this._axios = Axios.create();
  }

  get axios() {
    return this._axios;
  }

  get cancelToken() {
    return Axios.CancelToken;
  }

  get axiosLib() {
    return Axios;
  }

  async get(url, params) {
    return this._axios.get(url, params);
  }

  async put(url, data, params) {
    return this._axios.put(url, data, params);
  }

  async patch(url, data, params) {
    return this._axios.patch(url, data, { params });
  }

  async post(url, data, params) {
    return this._axios.post(url, data, params);
  }

  async delete(url, params) {
    return this._axios.delete(url, params);
  }
}

const api = new Api();
export default api;
